import z from 'zod'

// Street validation schemas
export const StreetSchema = z
  .string()
  .min(5, 'Street must be at least 5 characters long')
